import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const SandwichPreview = (props) => {
    const {
        platform,
        format,
        url
    } = props;

    return (
        <div className="ad-mode-content">
            <div className={classNames('social-image-sandwich-container', platform, format)}>
                <div className="social-img-top-bun" />
                <div className="social-img-meat-container">
                    <img className="social-img-meat" role="presentation" src={url} />
                </div>
                <div className="social-img-bottom-bun" />
            </div>
        </div>
    );
};

SandwichPreview.propTypes = {
    platform: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default SandwichPreview;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/sandwich_preview.js